import React, { useState, useEffect } from "react";
import { defaultStyles } from "../../../../../constants/style-constants/utils";
import IconInputTax from "../../../../styled-components/input/icon-input-tax";
import { Text } from "../../../../styled-components/text";
import * as Style from "./styles/capital-gains";
import { Button } from "../../../../styled-components/button";
import CarryForward from "../carry-forward/carry-forward";
import TaxCredits from "../tax-credits/tax-credits";
import { InputGroup } from "../../../../styled-components/input/styles/input";
import "../../styles/tax-inflation-style.css";
import { ToolTipCreator } from "../../../../../helpers/ToolTipCreator";
import {
  TaxSkeletonBox,
  TaxInflationButtonContent,
} from "../tax-inflation-loading";

function CapitalGains({
  handleTaxInflationObject,
  nextForm,
  preForm,
  data,
  taxInfo,
  parentLoading,
}) {
  const uniqueKey = Object.keys(data.capitalGains.data)[0];
  const capitalGainObj = data.capitalGains.data[uniqueKey];
  // const capitalGainObj = {
  //   subjectToCapGains: "",
  //   gainsRateFederal: "",
  //   gainsRateState: "",
  // };

  const capitalGainObjMain = {
    "Subject to Cap Gains": "50",
    "Gains Rate Federal": "80",
    "Gains Rate State": "10",
  };

  const [capitalGainData, setCapitalGainData] = useState({
    "Subject To Cap Gains":
      capitalGainObj && capitalGainObj["Subject To Cap Gains"],
    "Gains Rate Federal":
      capitalGainObj && capitalGainObj["Gains Rate Federal"],
    "Gains Rate State": capitalGainObj && capitalGainObj["Gains Rate State"],
    "Gains Rate Federal Short Term":
      capitalGainObj && capitalGainObj["Gains Rate Federal Short Term"],
    "Gains Rate State Short Term":
      capitalGainObj && capitalGainObj["Gains Rate State Short Term"],
  });

  const { styles } = defaultStyles;

  const handleCapitalGainInfo = (obj) => {
    const { name, value } = obj;

    setCapitalGainData({
      ...capitalGainData,
      [name]: value,
    });
  };
  useEffect(() => {
    if (taxInfo) {
      setCapitalGainData({
        "Subject To Cap Gains":
          taxInfo && taxInfo.amountWithdrawnCapGains
            ? taxInfo.amountWithdrawnCapGains
            : "",
        "Gains Rate Federal":
          taxInfo && taxInfo.capGainsRateFederal
            ? taxInfo.capGainsRateFederal
            : "",
        "Gains Rate State":
          taxInfo && taxInfo.capGainsRateState ? taxInfo.capGainsRateState : "",
        "Gains Rate Federal Short Term":
          taxInfo && taxInfo.capGainsRateFederalShortTerm
            ? taxInfo.capGainsRateFederalShortTerm
            : "",
        "Gains Rate State Short Term":
          taxInfo && taxInfo.capGainsRateStateShortTerm
            ? taxInfo.capGainsRateStateShortTerm
            : "",
      });
    }
  }, [taxInfo]);

  const nextComponent = {
    name: "carryForward",
    title: "Carry Forward",
    unique: "matric",
    isMulti: false,
    component: CarryForward,
    carryForward: {},
  };

  const preComponent = {
    name: "taxCredits",
    title: "Tax Credits",
    unique: "Other Tax Credit",
    isMulti: true,
    component: TaxCredits,
    taxCredits: {},
  };

  const submitData = () => {
    handleTaxInflationObject(capitalGainData);
    nextForm(nextComponent);
  };

  const fields = [
    // {
    //   Component: IconInputTax,
    //   value: {
    //     name: "Subject To Cap Gains",
    //     title: "Amount Withdrawn Subject To Cap Gains",
    //     icon: "%",
    //     value: capitalGainData["Subject To Cap Gains"],
    //     iconPosition: "end",
    //     onChange: (event) => handleCapitalGainInfo(event.target),
    //   },
    // },
    {
      Component: IconInputTax,
      value: {
        name: "Gains Rate Federal",
        title: "Federal Capital Gains Rate - Long Term",
        icon: "%",
        value: capitalGainData["Gains Rate Federal"],
        iconPosition: "end",
        onChange: (event) => handleCapitalGainInfo(event.target),
        tooltip: "Tax_Federal_Long-term-Cap_Gains",
      },
    },
    {
      Component: IconInputTax,
      value: {
        name: "Gains Rate Federal Short Term",
        title: "Federal Capital Gains Rate - Short Term",
        icon: "%",
        value: capitalGainData["Gains Rate Federal Short Term"],
        iconPosition: "end",
        onChange: (event) => handleCapitalGainInfo(event.target),
        tooltip: "Tax_Federal_Short-term-Cap_Gains",
      },
    },
    {
      Component: IconInputTax,
      value: {
        name: "Gains Rate State",
        title: "State Capital Gains Rate - Long Term",
        icon: "%",
        value: capitalGainData["Gains Rate State"],
        iconPosition: "end",
        onChange: (event) => handleCapitalGainInfo(event.target),
        tooltip: "Tax_State_Long-term-Cap_Gains",
      },
    },
    {
      Component: IconInputTax,
      value: {
        name: "Gains Rate State Short Term",
        title: "State Capital Gains Rate - Short Term",
        icon: "%",
        value: capitalGainData["Gains Rate State Short Term"],
        iconPosition: "end",
        onChange: (event) => handleCapitalGainInfo(event.target),
        tooltip: "Tax_State_Short-term-Cap_Gains",
      },
    },
  ];

  if (parentLoading) {
    return (
      <Style.MainContainer>
        <h3 style={{ color: "#2a3da3", fontWeight: "600", fontSize: "28px" }}>
          Capital Gains and Tax Rules
        </h3>
        <Style.MainTextContainer style={{ marginTop: "16px" }}>
          {[1, 2, 3, 4, 5].map((k) => (
            <div key={k} style={{ marginBottom: "12px" }}>
              <TaxSkeletonBox width={k % 2 ? "48%" : "72%"} height={14} />
              <TaxSkeletonBox width="100%" height={12} style={{ marginTop: "8px" }} />
            </div>
          ))}
        </Style.MainTextContainer>
        <Style.ButtonsContainer>
          <TaxSkeletonBox width={120} height={38} radius={999} />
          <TaxSkeletonBox width={120} height={38} radius={999} />
        </Style.ButtonsContainer>
      </Style.MainContainer>
    );
  }

  return (
    <Style.MainContainer>
      <h3 style={{ color: "#2a3da3", fontWeight: "600", fontSize: "28px" }}>
        Capital Gains and Tax Rules
      </h3>

      {/* <Style.FieldsContainer>
      {fields &&
        fields.map((data, index) => {
          const { value, Component, name, title, type, onChange } = data;
          return (
            <InputGroup key={index} style={{width:"30%"}}>
            <div style={{display:'flex', alignItems:'baseline', columnGap:'3px'}}>
              <Text style={styles.text.labelText} padding="2rem 0 1rem 0 ">
                {title || value.title}
              </Text>
              {value.tooltip && <ToolTipCreator name={value.tooltip}/>}
            </div>

              <Component
                key={index}
                value={value}
                name={name}
                onChange={onChange}
                type={type}
              />
            </InputGroup>
          );
        })}
    </Style.FieldsContainer>*/}
      <Style.MainTextContainer>
        <Style.TextHeader>Federal Long-Term Capital Gains</Style.TextHeader>
        <Style.TextContainer>
          The tax rate on long-term capital gains depends on your total taxable
          income.
        </Style.TextContainer>
        <Style.TextContainer>
          {" "}
          Our system automatically calculates this for you using the official
          0%, 15%, and 20% brackets.
        </Style.TextContainer>
        <Style.TextHeader>
          Federal Short-Term & California State Gains
        </Style.TextHeader>
        <Style.TextContainer>
          Short-term federal gains and all California capital gains are taxed at
          the same progressive rates as your regular income.
        </Style.TextContainer>
        <Style.TextContainer>
          Asset Planet will apply the appropriate ordinary income tax brackets
          during calculations.
        </Style.TextContainer>
      </Style.MainTextContainer>
      <Style.ButtonsContainer>
        <button
          className="tax-inflation-prev-button"
          disabled={parentLoading}
          onClick={() => preForm(preComponent)}
        >
          Previous
        </button>
        <button
          className="tax-inflation-next-button"
          disabled={parentLoading}
          onClick={submitData}
        >
          <TaxInflationButtonContent
            isLoading={parentLoading}
            idleText="Next"
            loadingText="Loading..."
          />
        </button>
      </Style.ButtonsContainer>
    </Style.MainContainer>
  );
}

export default CapitalGains;
